<script>
import { getList } from '@/api/v4ward/carv2/carmonth';

export default {
  props: {
    spaceList: {
      type: Array,
      required: true,
    },
    statusList: {
      type: Array,
      required: true,
    },
    carTypeList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    //车辆入场导出
    carMonthExportExcel(query) {
      this.$confirm('确定导出所选条件下的数据吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //设置导出标识
        query.exportExcelFlag = 0;
        getList(Object.assign({}, query)).then(({ data }) => {
          var spaceName;
          if (data != null && data.records.length > 0) {
            spaceName = data.records[0].spaceName;
          } else {
            this.$message.error('当前条件下无数据');
            return;
          }
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '车场名称',
              '车牌号',
              '通行区域',
              '车辆类型',
              '收费套餐',
              '租赁起期',
              '租赁止期',
              '支付时间',
              '应收金额',
              '客户姓名',
              '客户手机',
              '状态',
            ]; // 导出excel 的标题
            const filterVal = [
              'spaceId',
              'carNo',
              'regionsName',
              'carType',
              'ruleName',
              'buyStartTime',
              'buyEndTime',
              'payTime',
              'shouldMoney',
              'customerName',
              'customerPhone',
              'status',
            ]; // 每个标题对应的字段
            const list = (data.records || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                spaceId: this.getSpaceName(item.spaceId),
                carNo: item.carNo,
                regionsName: item.regionsName,
                carType: this.getCarTypeName(item.carType),
                ruleName: item.ruleName,
                buyStartTime: item.buyStartTime
                  ? this.dayjs(item.buyStartTime).format('YYYY-MM-DD')
                  : '',
                buyEndTime: item.buyEndTime ? this.dayjs(item.buyEndTime).format('YYYY-MM-DD') : '',
                payTime: item.payTime ? this.dayjs(item.payTime).format('YYYY-MM-DD') : '',
                shouldMoney: item.shouldMoney,
                customerName: item.customerName,
                customerPhone: item.customerPhone,
                status: this.getStatusName(item.status),
              };
            });
            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename:
                  spaceName + '月卡车管理记录' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            }
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getSpaceName(spaceId) {
      var spaceName = '';
      this.spaceList.forEach(function (value, index, array) {
        if (value.id == spaceId) {
          spaceName = value.title;
          return;
        }
      });
      return spaceName;
    },
    getStatusName(sataus) {
      var statusName = '';
      this.statusList.forEach(function (value, index, array) {
        if (value.dictKey == sataus) {
          statusName = value.dictValue;
          return;
        }
      });
      return statusName;
    },
    getCarTypeName(carType) {
      var carTypeName = '';
      this.carTypeList.forEach(function (value, index, array) {
        if (value.dictKey == carType) {
          carTypeName = value.dictValue;
          return;
        }
      });
      return carTypeName;
    },
  },
};
</script>

<style></style>
